export const formatDiscountAudience = (discountAudience) => {
  if (discountAudience === "team-member-vendor") {
    return "Team Member / Vendor";
  } else {
    return "Customer";
  }
};
